const helpers = {
  init(options) {
    this.setup(options)
    this.start()
    this.bind()
  },
  setup(options) {
    this.options = $.extend({
    }, options)
  },
  start() {
  },
  bind() {
  },
  isMobile() {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      return true
    } else {
      return false
    }
  }
}

export default helpers;